import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-070cceb9"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top-des"
}, "心愿似茧，梦想被小心包裹。", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top-des"
}, "想要幻化成哪种蝴蝶，都随你愿。", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top-des"
}, "一起助力，在无限未来努力探索…… ", -1));
const _hoisted_5 = {
  class: "list"
};
const _hoisted_6 = {
  class: "personal-info"
};
const _hoisted_7 = {
  class: "personal-list",
  style: {
    "z-index": "1"
  }
};
const _hoisted_8 = {
  class: "person-detail"
};
const _hoisted_9 = {
  class: "title"
};
const _hoisted_10 = {
  class: "score"
};
const _hoisted_11 = /*#__PURE__*/_createTextVNode("助力值 ");
const _hoisted_12 = {
  class: "num"
};
const _hoisted_13 = /*#__PURE__*/_createTextVNode();
const _hoisted_14 = {
  key: 0,
  class: "str"
};
const _hoisted_15 = {
  class: "next-goal"
};
const _hoisted_16 = /*#__PURE__*/_createTextVNode("距下一个破茧还差");
const _hoisted_17 = {
  class: "next-str"
};
const _hoisted_18 = /*#__PURE__*/_createTextVNode("助力值");
const _hoisted_19 = {
  class: "score"
};
const _hoisted_20 = /*#__PURE__*/_createTextVNode("助力值 ");
const _hoisted_21 = {
  class: "num"
};
const _hoisted_22 = {
  key: 0,
  class: "str"
};
const _hoisted_23 = {
  class: "team-info",
  id: "section-team"
};
const _hoisted_24 = {
  class: "team-list"
};
const _hoisted_25 = {
  class: "team-detail"
};
const _hoisted_26 = {
  class: "space-info"
};
const _hoisted_27 = {
  class: "title"
};
const _hoisted_28 = {
  class: "space-info"
};
const _hoisted_29 = {
  class: "des"
};
const _hoisted_30 = /*#__PURE__*/_createTextVNode("助力值 ");
const _hoisted_31 = {
  class: "num"
};
const _hoisted_32 = {
  class: "progress-num"
};
const _hoisted_33 = {
  class: "member-info"
};
const _hoisted_34 = {
  class: "member-list"
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "member-score-title"
}, "当前助力值累计", -1));
const _hoisted_36 = {
  class: "member-score-info"
};
const _hoisted_37 = {
  class: "score"
};
const _hoisted_38 = {
  class: "title"
};
const _hoisted_39 = {
  class: "des"
};
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "extra-info"
}, "集体权益分为向下兼容和完全替换两种，具体请参考原众筹页面12月28日内容补充", -1));
const _hoisted_41 = ["onClick"];
const _hoisted_42 = {
  class: "gold-num"
};
const _hoisted_43 = /*#__PURE__*/_createTextVNode("已筹款");
const _hoisted_44 = {
  class: "hover-acitons"
};
import { onBeforeUnmount, onMounted, reactive } from "vue";
import { getAKB48Info } from "@/api";
import { mdToast, fmoney, throttle } from "../../utils/tools";
import MDRouter from "../../service/router";
import env from "md-base-tools/env";
import domain from "@/service/domain";
import ShareBox from "@@/common/ShareBox.vue";
import { useStore } from 'vuex'; // 引入 useStore
import { useRoute } from "vue-router";
export default {
  setup(__props) {
    const route = useRoute();
    const store = useStore(); // 获取 Vuex store

    // 调用 mutation
    const triggerChangeShareStatus = () => {
      store.commit('currentShareUpdate', {
        obj: 'share_info',
        value: state.shareInfo
      }); // 调用 changeShareStatus mutation

      store.commit('changeShareStatus', {
        obj: 'showShare'
      }); // 调用 changeShareStatus mutation
    };

    /* 0 level 0 */
    /* 1-10000 level1/
    /* 30000 level 2 */
    /* 120000 level 3 */
    /* 300000 level 4 */

    const state = reactive({
      is_ip: false,
      pro_id: '137048',
      show_actions: false,
      show_top_btn: false,
      total_amount: '',
      total_score: '',
      person_list: [],
      team_list: [],
      member_list: [{
        'title': '助力值到 40万',
        'content': '16人原创曲1首',
        'is_lock': true
      }, {
        'title': '助力值到 50万',
        'content': '16人原创曲1首+编舞+CD发行',
        'is_lock': true
      }, {
        'title': '助力值到 60万',
        'content': '16人原创曲1首+MV',
        'is_lock': true
      }, {
        'title': '助力值到 70万',
        'content': '半套原创公演8-9首歌曲，混合其他版权歌组成新公演',
        'is_lock': true
      }, {
        'title': '助力值到 80万',
        'content': '本部歌曲3首录制',
        'is_lock': true
      }, {
        'title': '助力值到 90万',
        'content': '本部歌曲3首录制+编舞+CD发行',
        'is_lock': true
      }, {
        'title': '助力值到 100万',
        'content': '本部歌曲3首录制+1首MV',
        'is_lock': true
      }, {
        'title': '助力值到 120万',
        'content': '半套本部公演8-9首歌曲，混合其他版权歌组成新公演',
        'is_lock': true
      }, {
        'title': '助力值到 140万',
        'content': '半套本部公演8-9首歌曲，混合其他版权歌组成新公演，1首MV',
        'is_lock': true
      }, {
        'title': '助力值到 150万',
        'content': '解锁原创公演一套，16首歌',
        'is_lock': true
      }],
      shareInfo: {
        active_title: "",
        img: "https://p6.moimg.net/mdwxapp/akb48/wx_share_icon.jpg",
        mina_app_name: "gh_7210ac3f1f08",
        // gh_5638b10d3ccb
        mina_share_img: "https://p6.moimg.net/mdwxapp/akb48/mina_share_icon.png",
        mina_share_path: `pages/index/index?nextUrl=pages/webviewPages/content/content&url=${domain.wap}/mdactivity/fastsell/akb48`,
        msg_des: "AKB48 Team SH 六周年嘉年华，助力你喜欢的成员破茧成蝶，达成梦想",
        qq_des: "AKB48 Team SH 六周年嘉年华，助力你喜欢的成员破茧成蝶，达成梦想",
        qq_share_url: `${domain.wap}/mdactivity/fastsell/akb48`,
        qq_title: "心愿之茧 蝶梦翩翩 TSHcard第二弹",
        qr_img: "https://p6.moimg.net/mdwxapp/akb48/wx_share_icon.jpg",
        qzone_share_url: `${domain.wap}/mdactivity/fastsell/akb48`,
        share_url: `${domain.wap}/mdactivity/fastsell/akb48`,
        sharelink_url: `${domain.wap}/mdactivity/fastsell/akb48`,
        small_code: "",
        weibo_des: "AKB48 Team SH 六周年嘉年华，助力你喜欢的成员破茧成蝶，达成梦想" + `${domain.wap}/mdactivity/fastsell/akb48` + '（分享自@摩点）',
        weibo_share_url: `${domain.wap}/mdactivity/fastsell/akb48`,
        weibo_title: "心愿之茧 蝶梦翩翩 TSHcard第二弹",
        weixin_share_url: `${domain.wap}/mdactivity/fastsell/akb48`,
        wxTimeline_share_url: `${domain.wap}/mdactivity/fastsell/akb48`,
        wx_des: "AKB48 Team SH 六周年嘉年华，助力你喜欢的成员破茧成蝶，达成梦想",
        wx_title: "心愿之茧 蝶梦翩翩 TSHcard第二弹"
      }
    });
    let hideTimeout = null;

    // 滚动事件处理
    const onScroll = throttle(async function () {
      if (window.scrollY >= window.innerHeight / 2) {
        state.show_top_btn = true;
      } else {
        state.show_top_btn = false;
      }
      // 判断页面滚动位置
      if (window.scrollY > 10) {
        // console.log('-----state.show_actions-----',window.scrollY,state.show_actions)

        if (state.show_actions == false) {
          state.show_actions = true; // 滚动时显示按钮
          // console.log('-----显示按钮-----')
          // 清除之前的隐藏定时器
          if (hideTimeout) {
            // console.log('-----删除定时器-----')
            clearTimeout(hideTimeout);
          }

          // console.log('-----创建定时器-----')
          // 设置定时器，2秒后隐藏按钮
          hideTimeout = setTimeout(() => {
            state.show_actions = false;
            // console.log('-----隐藏按钮-----')
          }, 3000);
        }
      }
    }, 100);
    onMounted(() => {
      document.title = "心愿之茧，蝶梦翩翩";
      state.is_ip = route.query.is_ip == 1 ? true : false;
      if (route.query.pro_id) {
        state.pro_id = route.query.pro_id;
      }
      //   console.log('params----',route)

      requestAKBInfo();
      window.addEventListener('scroll', onScroll);
      if (env.isModianIos() || env.isModianAndroid()) {
        // eslint-disable-next-line no-undef
        graft.app({
          functionName: "webNavColor",
          functionParams: {
            statusBarColorIsWhite: '1'
          }
        });
      }
    });
    onBeforeUnmount(() => {
      window.removeEventListener('scoll', onScroll);
    });
    async function requestAKBInfo() {
      const {
        status,
        data,
        message
      } = await getAKB48Info({
        'pro_id': state.pro_id
      });
      if (status == 0) {
        // console.log('data----',data)
        // 个人愿望
        state.person_list = data.person_list;
        // 小分队
        state.team_list = data.team_list;
        // 筹款总金额
        state.total_amount = data.total_amount;
        // 总助力值
        state.total_score = data.total_score;
        if (data.total_score >= 400000) {
          state.member_list[0].is_lock = false;
        }
        if (data.total_score >= 500000) {
          state.member_list[1].is_lock = false;
        }
        if (data.total_score >= 600000) {
          state.member_list[2].is_lock = false;
        }
        if (data.total_score >= 700000) {
          state.member_list[3].is_lock = false;
        }
        if (data.total_score >= 800000) {
          state.member_list[4].is_lock = false;
        }
        if (data.total_score >= 900000) {
          state.member_list[5].is_lock = false;
        }
        if (data.total_score >= 1000000) {
          state.member_list[6].is_lock = false;
        }
        if (data.total_score >= 1200000) {
          state.member_list[7].is_lock = false;
        }
        if (data.total_score >= 1400000) {
          state.member_list[8].is_lock = false;
        }
        if (data.total_score >= 1500000) {
          state.member_list[9].is_lock = false;
        }
      } else {
        mdToast(message);
      }
    }

    // 个人愿望

    function nextScoreFormat(item) {
      return Number(item.goal_score) - Number(item.score);
    }
    function progressColor(item) {
      let result = {};
      switch (item.level) {
        case 1:
          {
            //写真集-显示LIGHT颜色
            result = {
              'back': 'rgba(146, 207, 242, 0.15)',
              'line': '#92CFF2'
            };
          }
          break;
        case 2:
          {
            //LIGHT-显示BASIC颜色
            result = {
              'back': 'rgba(176, 131, 240, 0.15)',
              'line': '#B083F0'
            };
          }
          break;
        case 3:
          {
            //BASIC-显示LYXURY颜色
            result = {
              'back': 'rgba(255, 141, 209, 0.15)',
              'line': '#FF8DD1'
            };
          }
          break;
        case 4:
          {
            //LYXURY-显示LYXURY颜色
            result = {
              'back': 'rgba(255, 141, 209, 0.15)',
              'line': '#FF8DD1'
            };
          }
          break;
        default:
          result = {
            'back': 'rgba(146, 242, 187, 0.15)',
            'line': '#92F2BB'
          };
          break;
      }
      return result;
    }
    function progressLine(item) {
      if (item.score >= item.goal_score) {
        return 100;
      }
      return Math.floor(item.score / item.goal_score * 100);
    }
    function progresNum(item) {
      if (item.score >= item.goal_score) {
        return '100%';
      }
      return Math.floor(item.score / item.goal_score * 100) + '%';
    }
    function memberScoreFormat(score) {
      // console.log('score-----',score)
      if (score < 10000) {
        return score.toString(); // 如果小于1万，直接返回
      } else {
        // 超过1万，保留两位小数，直接舍去多余部分
        const result = Math.floor(score / 10000 * 100) / 100;
        return result + '万';
      }
    }
    function moneyFormat(money) {
      return Number(money) < 10000 ? fmoney(money) : (money / 10000).toFixed(2);
    }
    function handleSupportAction() {
      MDRouter.goProInfo(state.pro_id);
    }
    function handleTeamAction() {
      scrollToSection('section-team');
    }
    function handleTopAction() {
      scrollToSection('section-top');
    }
    function scrollToSection(sectionId) {
      const target = document.getElementById(sectionId); // 获取对应模块
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        }); // 平滑滚动
      }
    }
    function handleShareAction() {
      if (env.isModianIos() || env.isModianAndroid()) {
        // eslint-disable-next-line no-undef
        graft.app({
          functionName: 'openShareTool',
          functionParams: JSON.parse(JSON.stringify(state.shareInfo))
        });
      } else {
        triggerChangeShareStatus();
      }
    }
    function handleRuleAction() {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `https://m.modian.com/ip/webActivity/783`,
        webFun: () => {
          location.href = 'https://m.modian.com/ip/webActivity/783';
        }
      });
    }
    function handleBackAction() {
      MDRouter.GoBack();
    }
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_progress = _resolveComponent("van-progress");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_image, {
        id: "section-top",
        class: "cover banner",
        "lazy-load": "",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/akb48/back_top.png', 750)
      }, null, 8, ["src"]), (_unref(env).isModianIos() || _unref(env).isModianAndroid()) && !_unref(state).is_ip ? (_openBlock(), _createBlock(_component_van_image, {
        key: 0,
        class: "back-icon",
        "lazy-load": "",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/akb48/back_icon.png', 70),
        onClick: _withModifiers(handleBackAction, ["stop"])
      }, null, 8, ["src", "onClick"])) : _createCommentVNode("", true), _createVNode(_component_van_image, {
        class: "cover top_star",
        "lazy-load": "",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/akb48/team_icon.png', 102)
      }, null, 8, ["src"]), _hoisted_2, _hoisted_3, _hoisted_4, _createVNode(_component_van_image, {
        class: "cover activity_icon",
        "lazy-load": "",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/akb48/activity_icon.png', 446),
        onClick: _withModifiers(handleRuleAction, ["stop"])
      }, null, 8, ["src", "onClick"]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_van_image, {
        class: "cover",
        "lazy-load": "",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/akb48/person_list_top.png', 640)
      }, null, 8, ["src"]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_van_image, {
        class: "personal-star",
        "lazy-load": "",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/akb48/personal_star.png', 113)
      }, null, 8, ["src"]), _createVNode(_component_van_image, {
        class: "left-star",
        "lazy-load": "",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/akb48/list_star.png', 33)
      }, null, 8, ["src"]), _createVNode(_component_van_image, {
        class: "right-star",
        "lazy-load": "",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/akb48/list_star.png', 33)
      }, null, 8, ["src"]), _createVNode(_component_van_image, {
        class: "cover rule_icon",
        "lazy-load": "",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/akb48/rule_icon.png', 554)
      }, null, 8, ["src"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).person_list, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "person-item"
        }, [_createVNode(_component_van_image, {
          class: "person-icon",
          "lazy-load": "",
          src: _ctx.$imgUrlFilter(item.reward_logo, 110)
        }, null, 8, ["src"]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(item.reward_title), 1), item.score < item.goal_score ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("span", _hoisted_12, _toDisplayString(item.score), 1), _hoisted_13, item.current_level_name || item.current_level_content ? (_openBlock(), _createElementBlock("span", _hoisted_14, "| 获得" + _toDisplayString(item.current_level_name) + _toDisplayString(item.current_level_content), 1)) : _createCommentVNode("", true)]), _createVNode(_component_van_progress, {
          class: "progress-line",
          percentage: progressLine(item),
          "pivot-text": "",
          "track-color": progressColor(item).back,
          color: progressColor(item).line,
          "stroke-width": "8"
        }, null, 8, ["percentage", "track-color", "color"]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("span", _hoisted_17, _toDisplayString(nextScoreFormat(item)), 1), _hoisted_18])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createElementVNode("div", _hoisted_19, [_hoisted_20, _createElementVNode("span", _hoisted_21, _toDisplayString(item.score), 1)]), item.current_level_name || item.current_level_content ? (_openBlock(), _createElementBlock("div", _hoisted_22, "获得" + _toDisplayString(item.current_level_name) + _toDisplayString(item.current_level_content), 1)) : _createCommentVNode("", true)], 64))])]);
      }), 128))]), _createVNode(_component_van_image, {
        class: "cover",
        "lazy-load": "",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/akb48/common_list_bottom.png', 640)
      }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_23, [_createVNode(_component_van_image, {
        class: "cover",
        "lazy-load": "",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/akb48/team_list_back.png', 640)
      }, null, 8, ["src"]), _createVNode(_component_van_image, {
        class: "team-star",
        "lazy-load": "",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/akb48/team_star.png', 122)
      }, null, 8, ["src"]), _createElementVNode("div", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).team_list, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "team-item"
        }, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, _toDisplayString(item.teamund_name), 1), _createElementVNode("div", {
          class: _normalizeClass(['lock-icon', {
            'unlock': item.unlock
          }])
        }, _toDisplayString(item.unlock ? '破茧成功' : '待破茧'), 3)]), _createVNode(_component_van_progress, {
          class: "progress-line",
          percentage: progressLine(item),
          "pivot-text": "",
          "track-color": "rgba(255, 141, 209, 0.15)",
          color: "#FF8DD1",
          "stroke-width": "8"
        }, null, 8, ["percentage"]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_hoisted_30, _createElementVNode("span", _hoisted_31, _toDisplayString(item.score), 1)]), _createElementVNode("div", _hoisted_32, _toDisplayString(progresNum(item)), 1)])])]);
      }), 128))])]), _createElementVNode("div", _hoisted_33, [_createVNode(_component_van_image, {
        class: "cover",
        "lazy-load": "",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/akb48/member_list_top.png', 640)
      }, null, 8, ["src"]), _createElementVNode("div", _hoisted_34, [_hoisted_35, _createElementVNode("div", _hoisted_36, [_createVNode(_component_van_image, {
        class: "cover",
        "lazy-load": "",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/akb48/member_icon.png', 640)
      }, null, 8, ["src"]), _createElementVNode("div", _hoisted_37, _toDisplayString(memberScoreFormat(_unref(state).total_score)), 1)]), _createVNode(_component_van_image, {
        class: "left-star",
        "lazy-load": "",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/akb48/list_star.png', 33)
      }, null, 8, ["src"]), _createVNode(_component_van_image, {
        class: "right-star",
        "lazy-load": "",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/akb48/list_star.png', 33)
      }, null, 8, ["src"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).member_list, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(['member-item', {
            'unlock': item.is_lock == false
          }])
        }, [_createElementVNode("div", _hoisted_38, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_39, _toDisplayString(item.content), 1), _createVNode(_component_van_image, {
          class: "cover",
          "lazy-load": "",
          src: _ctx.$imgUrlFilter(item.is_lock ? 'https://p6.moimg.net/mdwxapp/akb48/member_lock.png' : 'https://p6.moimg.net/mdwxapp/akb48/member_unlock.png', 60)
        }, null, 8, ["src"])], 2);
      }), 128)), _hoisted_40]), _createVNode(_component_van_image, {
        class: "cover",
        "lazy-load": "",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/akb48/common_list_bottom.png', 640)
      }, null, 8, ["src"])])]), _createElementVNode("div", {
        class: _normalizeClass(['action-info', {
          'is_ip': _unref(state).is_ip
        }])
      }, [_createElementVNode("div", {
        class: "btn-info",
        onClick: _withModifiers(handleSupportAction, ["stop"])
      }, [_createElementVNode("div", _hoisted_42, [_hoisted_43, _createElementVNode("span", null, _toDisplayString(moneyFormat(_unref(state).total_amount)), 1), _createTextVNode(_toDisplayString(_unref(state).total_amount >= 10000 ? '万' : '元'), 1)]), _createVNode(_component_van_image, {
        class: "action-btn",
        "lazy-load": "",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/akb48/support_btn.png', 333)
      }, null, 8, ["src"])], 8, _hoisted_41)], 2), _createVNode(_Transition, {
        name: "fade"
      }, {
        default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_44, [_withDirectives(_createVNode(_component_van_image, {
          class: "hover-btn",
          src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/akb48/action_top.png', 142),
          onClick: _withModifiers(handleTopAction, ["stop"])
        }, null, 8, ["src", "onClick"]), [[_vShow, _unref(state).show_top_btn]]), _createVNode(_component_van_image, {
          class: "hover-btn",
          src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/akb48/action_team.png', 142),
          onClick: _withModifiers(handleTeamAction, ["stop"])
        }, null, 8, ["src", "onClick"]), !_unref(env).isWxApp() ? (_openBlock(), _createBlock(_component_van_image, {
          key: 0,
          class: "hover-btn",
          src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/akb48/action_share.png', 142),
          onClick: _withModifiers(handleShareAction, ["stop"])
        }, null, 8, ["src", "onClick"])) : _createCommentVNode("", true)], 512), [[_vShow, _unref(state).show_actions]])]),
        _: 1
      }), _createVNode(ShareBox)]);
    };
  }
};